export enum MediaDeviceTypes {
  audioInput = 'audioinput',
  audioOutput = 'audiooutput',
  videoInput = 'videoinput',
}
